import { ComboBox } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { isValidEmail } from '../../../../../../../../../../../../../../../../utils/isValidEmail'
import { useRecurringInvoiceForm } from '../../../../../../../../../../../../contexts/recurringInvoiceFormContext'
import { useContactPersonItems } from '../../../../hooks/useContactPersonItems'

export const EmailRecipients = (): ReactElement => {
  const { t } = useTranslation()
  const { contactPersonItems } = useContactPersonItems()
  const { recurringInvoiceForm } = useRecurringInvoiceForm()
  const { FormItem } = recurringInvoiceForm

  return (
    <FormItem
      name="message.to"
      label={t('external_invoices.editor.form.recurring_invoice_settings.email_template.modal.field.to.label')}
      render={({ field: { value, ...props } }) => {
        return (
          <ComboBox
            {...props}
            isMultiselect
            items={contactPersonItems}
            placeholder={t(
              'external_invoices.editor.form.recurring_invoice_settings.email_template.modal.field.to.placeholder',
            )}
            selectedValues={value}
            size="sm"
            validateItem={isValidEmail}
          />
        )
      }}
    />
  )
}
